import * as React from 'react';
import { GetSettings } from '../../../functions/StateManagement/StateStorageFunctions';
import { DashboardOrganizer } from '../../../functions/WidgetDashboardOrganizer';
import NewTicketWidget from '../../TicketingSystemComponents/TicketWidgets/NewTicketWidget';
import { SupervisorEmployeeManagementWidget } from '../Widgets/SupervisorEmployeeManagementWidget';
import { getUserID } from '../../../functions/authActions';
import EmployeePositionChangeRequestModal from '../../PayrollComponents/EmployeeChangeRequest/EmployeePositionChangeModal';
import OnboardingAndOffboardingTriggerWidget from '../Widgets/OnboardingAndOffboardingTriggerWidget';
import { RenderSettings } from '../../../interfaces/WidgetSettingsInterfaces';
import ReasonableAccomodationWidget from '../Widgets/ReasonableAccomodationWidget';
import TicketSummaryLookupWidget from '../../TicketingSystemComponents/TicketWidgets/TicketSummaryLookupWidget';
import DashboardHeaderRow from '../../CoreComponents/DashboardHeaderRow';
import { DashboardOrganizationState } from '../interfaces';
import PayrollDashboard from './Preset/PayrollDashboard';

export default class TechnologyTeamLeadDashboard extends React.Component<{}, DashboardOrganizationState> {

  settingsString: string = "techLeadTicketDashboard";

  teamLeadDefaults: RenderSettings = {
    rows: [
      {
        col: 3,
        widgets: [0, 7, 5]
      }
    ]
  }

  constructor(props: {}) {
    super(props);
    let settings: RenderSettings = GetSettings<RenderSettings>(this.settingsString);
    if (settings === null) {
      settings = this.teamLeadDefaults
    }
    this.state = {
      renderSettings: settings,
      displayWidgets: [],
      widgetList: []
    }
    DashboardOrganizer.bind(this);
  }

  async componentDidMount(): Promise<void> {
    await this.prepareDasboard();
  }

  async prepareDasboard(): Promise<void> {
    let displayWidgets: { [key: number]: JSX.Element } = {
      0: <NewTicketWidget />,
      1: <SupervisorEmployeeManagementWidget supervisorUID={getUserID()} />,
      5: <OnboardingAndOffboardingTriggerWidget />,
      6: <ReasonableAccomodationWidget />,
      7: <TicketSummaryLookupWidget />,
      8: <PayrollDashboard />
    }
    let widgetList = [
      { label: "New Tickets", value: "0" },
      { label: "Employee Management", value: "1" },
      { label: "Start Onboard/Offboard", value: "5" },
      { label: "Reasonable Accomodations", value: "6" },
      { label: "Ticket Summary Lookup", value: "7" },
      { label: "Payroll Dashboard", value: "8"}
    ]
    this.setState({
      displayWidgets: displayWidgets,
      widgetList: widgetList
    })
  }

  updateUI = (settings: RenderSettings): void => {
    this.setState({ renderSettings: settings })
  }

  render(): JSX.Element {
    return (
      <>
        <EmployeePositionChangeRequestModal />
        <DashboardHeaderRow
          dashboardTitle={"Technology Lead Dashboard"}
          settingsString={this.settingsString}
          displayList={this.state.displayWidgets}
          widgetList={this.state.widgetList}
          updateUI={this.updateUI}
        />
        {DashboardOrganizer(this.state.displayWidgets, this.state.renderSettings)}
      </>
    )
  }
}